import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Rule } from '../shared/models/rule.model';

@Injectable()
export class RuleService {
  private http = inject(HttpClient);


  add(rule: Rule): Observable<void> {
    return this.http.post<void>('/api/twitter/rules', rule);
  }

  validate(rule: Rule): Observable<void> {
    return this.http.post<void>('/api/twitter/validate', rule);
  }

  getAll(): Observable<Rule[]> {
    return this.http.get<Rule[]>('/api/twitter/rules');
  }

  update(rule: Rule): Observable<void> {
    return this.http.put<void>('/api/twitter/rules', rule);
  }

  delete(rule: Rule): Observable<void> {
    return this.http.delete<void>(`/api/twitter/rules/${rule.id}`);
  }

}
